import { isEmpty } from 'ramda';

import { SEVERITY } from 'constants/ChecklistConstants';
import { DEFAULT_LANGUAGE } from 'constants/LanguageConstants';
import { AuditQuestionTypeEnum } from 'modules/audits/types/resources/audits.enum';

/**
 *
 * @param {*} params current params for audit statistics call
 * @param {*} filters filters on question value provided in audit statistics dashboard
 */
export const addFiltersToParams = (params, filters) => {
  const newParams = { ...(params ?? {}) };
  if (filters) {
    newParams.question = Object.entries(filters).map(([questionId, questionFilters]) => {
      const formattedFilters = Object.entries(questionFilters)
        .map(([property, values]) => `${property}:${values.join(',')}`)
        .join(',');
      return `${questionId},${formattedFilters}`;
    });
  }
  return newParams;
};

/**
 * Check Translate.js, similar behavior
 *  If audit model has languages
 *    If only one language
 *    If it has the current ui language we take it
 *    If it has dealer language we take it
 *    If it has 'en' we take it
 *    Else we take the first language
 *  Else we take dealer default language
 * @param {Array} languages
 * @param {String} currentLanguage
 * @param {String} dealerDefaultLanguage
 * @return {String}
 */
export const getLanguageToUse = (languages, currentLanguage, dealerDefaultLanguage) => {
  if (languages && !isEmpty(languages)) {
    if (languages.length === 1) {
      return languages[0];
    }

    if (languages.includes(currentLanguage)) {
      return currentLanguage;
    }
    if (languages.includes(dealerDefaultLanguage)) {
      return dealerDefaultLanguage;
    }
    if (languages.includes(DEFAULT_LANGUAGE)) {
      return DEFAULT_LANGUAGE;
    }
    return languages[0];
  }
  return dealerDefaultLanguage;
};

/**
 * This function can be removed once components are split into smaller ones
 * Currently used in Generic/Pie question
 */
export const getQuestionReducer = questionType => {
  switch (questionType) {
    case AuditQuestionTypeEnum.AUTHOR:
      return 'author,none';
    case AuditQuestionTypeEnum.BRAND:
      return 'brand,none';
    case AuditQuestionTypeEnum.CHECKBOX:
    case AuditQuestionTypeEnum.RADIO_BUTTON:
      return 'choice,none';
    case AuditQuestionTypeEnum.MULTI_EMPLOYEE:
    case AuditQuestionTypeEnum.EMPLOYEE:
      return 'employee,none';
    case AuditQuestionTypeEnum.YES_NO:
      return 'choice';
    case AuditQuestionTypeEnum.SEVERITY:
      return 'severity';
    case AuditQuestionTypeEnum.KPI:
      return 'label';
    default:
      return undefined;
  }
};

/**
 * This function can be removed once mobile app uses the right label for the right severity when creating audits
 */
const getItemSeverityLabel = item => (item.severity === SEVERITY.NONE ? 'GOOD' : item.severity);

/**
 * This function can be removed once components are split into smaller ones
 * Currently used in PieQuestion
 */
export const getQuestionLabel = (intl, item, questionType) => {
  const questionReducer = getQuestionReducer(questionType);
  const isUnanswered = !item[questionReducer] || item[questionType] === '';
  switch (questionType) {
    case AuditQuestionTypeEnum.YES_NO:
      // stats.
      return intl.formatMessage({
        id: isUnanswered ? 'page.stats.unanswered' : `page.stats.${item.choice.toLowerCase()}`,
        defaultMessage: isUnanswered ? 'Unanswered' : item.choice.toLowerCase(),
      });
    case AuditQuestionTypeEnum.SEVERITY:
      return intl.formatMessage({
        id: isUnanswered ? 'page.stats.unanswered' : `audito.model.severity.${getItemSeverityLabel(item)}`,
        defaultMessage: isUnanswered ? 'Unanswered' : getItemSeverityLabel(item),
      });
    case AuditQuestionTypeEnum.KPI:
      return intl.formatMessage({
        id: isUnanswered ? 'page.stats.unanswered' : item.label.toLowerCase(),
        defaultMessage: isUnanswered ? 'Unanswered' : item.label.toLowerCase(),
      });
    default:
      return undefined;
  }
};
